module.exports = new __parcel__URL__("loyalty-offer.b5991da5.png").toString();